import queryString from 'query-string';

export function createQueryParamsFromLocation(): Map<
  string,
  string | undefined
> {
  const parsedParams = queryString.parse(location.search);

  const params = new Map<string, string>();

  for (const [key, value] of Object.entries(parsedParams)) {
    if (Array.isArray(value)) {
      params.set(key, value[0]!);
    } else if (value) {
      params.set(key, value);
    }
  }

  return params;
}